export default __webpack_public_path__ + "static/media/calculate_tax.367a94de.png";